import { InputAdornment } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekInputAdornment = styled(InputAdornment)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h4), { backgroundColor: theme.palette.secondary.contrastText })));

export { PeekInputAdornment, PeekInputAdornment as default };
